"use client";
function D(t, e, n) {
  if (!t) return;
  const o = n ? $(t) : "", i = x(e), s = {
    workflow: S(t),
    attachments: e
  };
  return {
    context: l([o, i]),
    attributes: s
  };
}
function $(t) {
  const { displayName: e, goals: n, informationToCollect: o, guidance: i, botPersona: s, context: u } = t, a = r({
    title: "Guidance",
    content: [g(i)],
    note: s,
    depth: 2
  }), p = m(
    o?.filter((c) => c.required).map((c) => c.description)
  ), f = m(
    o?.filter((c) => !c.required).map((c) => c.description)
  ), h = r({
    title: "Required",
    content: [p],
    note: "IMPORTANT: This information is REQUIRED for this workflow. If not provided in the conversation, prompt the user to provide it and don't otherwise answer their question.",
    depth: 3
  }), w = r({
    title: "Optional",
    content: [f],
    depth: 3
  }), v = r({
    title: "Information to collect",
    content: [h, w],
    note: "This is information that should be collected from the user.",
    depth: 2
  }), T = m(u), A = r({
    title: "Context",
    content: [T],
    depth: 2
  }), C = r({
    title: "Workflow Name",
    content: [e],
    depth: 2
  }), I = r({
    title: "Goals",
    content: [g(n)],
    depth: 2
  });
  return r({
    title: "Workflow",
    content: [
      "I am a user being guided through a “workflow” defined by the organization that provides this chat experience.",
      "**IMPORTANT: Follow the instructions outlined in this workflow. Follow the instructions in the workflow configuration below. Do not answer questions unrelated to the workflow.**",
      C,
      I,
      A,
      v,
      a
    ],
    depth: 1
  });
}
function g(t) {
  if (d(t))
    return t.filter((e) => e != null).map((e, n) => `${n + 1}. ${e}`).join(`
`);
}
function m(t) {
  if (d(t))
    return t.filter((e) => e != null).map((e) => `- ${e}`).join(`
`);
}
function r({ title: t, content: e, note: n, depth: o = 2 }) {
  const i = l(e);
  if (!i && !n) return;
  const u = `${"#".repeat(o)} ${t}
`, a = l([n, i]);
  return a ? `${u}${a}
` : void 0;
}
function k(t) {
  if (!t || !d(t)) return;
  const e = t.map(
    (n, o) => M({ attachment: n, index: o })
  );
  return l(e);
}
function x(t) {
  const e = k(t);
  return r({
    title: "User-provided Attachments",
    content: ["The user has provided the following attachments to their message:", e],
    depth: 1
  });
}
function y(t) {
  if (t?.type === "CODE")
    return t.language || "";
}
function b(t, e) {
  return e ? `\`\`\`${e}
${t}
\`\`\`` : t;
}
function M({ attachment: t, index: e }) {
  const { title: n, content: o, contentType: i, context: s } = t, { contentInputLabel: u, type: a } = i, p = y(i), f = b(o, p), h = d(s) ? [`
Additional Context:`, l(s)] : [];
  return [
    `#### ATTACHMENT #${e + 1}`,
    `Title: ${n}`,
    `Label: ${u}`,
    `Type: ${a}`,
    "Content:",
    f,
    ...h
  ].join(`
`);
}
function S(t) {
  if (!t.supportedInputs)
    return t;
  const e = { ...t };
  return e.supportedInputs = t.supportedInputs.map((n) => {
    const o = { ...n };
    return o.type === "MODAL" && (o.workflowModalProps = void 0), o;
  }), e;
}
function l(t) {
  if (d(t))
    return t.filter((e) => e != null).join(`
`);
}
function d(t) {
  return Array.isArray(t) && t.length > 0;
}
export {
  D as getMessageMetadata,
  x as serializeAttachments,
  $ as serializeWorkflow,
  k as stringifyAttachments
};
